import { useContext, useEffect } from 'react';
import ScrollToContext from 'providers/ScrollTo/ScrollTo.context';

export function useLockScrollOnParamsReroute() {
  const { setShouldScrollOnParams } = useContext(ScrollToContext);

  useEffect(() => {
    setShouldScrollOnParams(false);

    return () => {
      setShouldScrollOnParams(true);
    };
  }, [setShouldScrollOnParams]);
}
